var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('el-cascader',{attrs:{"title":_vm.region,"props":_vm.area},on:{"change":_vm.handleChanges},model:{value:(_vm.region),callback:function ($$v) {_vm.region=$$v},expression:"region"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }